<template>
  <el-dialog
    title="发券列表"
    :visible.sync="dialogVisible"
    width="880px"
    :close-on-click-modal="false"
  >
    <el-table
      :data="couponList"
      border
      style="width: 100%"
      height="600"
      show-summary
      :summary-method="getSummaries"
    >
      <el-table-column prop="shopName" label="客户名称" />
      <el-table-column prop="sendNumber" label="发券数量" width="100" />
      <el-table-column prop="usedNumber" label="已用" width="100" />
      <el-table-column prop="sendShopName" label="发券人" width="120" />
      <el-table-column prop="collectionTime" label="发券时间" width="180" />
      <el-table-column label="操作" width="80" align="center">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="handleRevoke(scope.row)"
            >撤回</el-button
          >
        </template>
      </el-table-column>
    </el-table>
  </el-dialog>
</template>

<script>
import { getSendCouponList, rollBackCoupon } from "@/api/coupon";
export default {
  data() {
    return {
      dialogVisible: false,
      couponCode: "",
      couponList: [],
    };
  },
  methods: {
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        if (
          column.property === "sendNumber" ||
          column.property === "usedNumber"
        ) {
          const values = data.map((item) => Number(item[column.property]));
          sums[index] = values.reduce((prev, curr) => {
            return prev + curr;
          }, 0);
        } else {
          sums[index] = "";
        }
      });
      return sums;
    },
    publicOpen(coupon) {
      this.couponCode = coupon.couponCode;
      this.dialogVisible = true;
      this.getCouponList();
    },
    getCouponList() {
      getSendCouponList({
        couponCode: this.couponCode,
      }).then((res) => {
        this.couponList = res.data || [];
      });
    },
    handleRevoke(row) {
      this.$confirm(
        `您将撤回"${row.shopName}"的"${row.couponName}"${row.sendNumber}张，是否确认？`,
        "撤回",
        {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          rollBackCoupon({
            couponCode: row.couponCode,
            numbers: row.sendNumber,
            shopId: row.shopId,
          }).then(() => {
            this.$message.success("撤回成功");
            this.getCouponList();
            this.$emit("rollBackSuccess");
          });
        })
        .catch(() => {
          this.$message.info("已取消撤回");
        });
    },
  },
};
</script>

<style scoped>
.el-table {
  margin-bottom: 20px;
}
</style>
